import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { displayErrorText } from '../../../../api/errors/api-error-codes';
import { PendingJournalEntryWithLinesEntity } from '../../../../api/types/accounting/journal-entries/pending-journal-entry-with-lines-entity';
import { PaymentMethodsDb } from '../../../../api/types/students/payment-services/user-payments/user-payment-service-with-price-list';

export interface GetPendingJournalEntriesForReportPayload {
  offset: number;
  limit: number;
  fromDate?: Date | null;
  toDate?: Date | null;
  paymentMethod?: PaymentMethodsDb[];
  chartOfAccountIds?: number[];
}

// The backend strictly expects `fromDate` / `toDate` as `dd/mm/yyyy` strings
// (see Joi `DD_MM_YYYY_PATTERN` on the route). We format on the client to
// avoid a round-trip via the user's locale.
const formatDateAsDdMmYyyy = (date: Date | null | undefined): string | null => {
  if (!date) return null;
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear());
  return `${day}/${month}/${year}`;
};

export const getPendingJournalEntriesForReportOperation = async (
  payload: GetPendingJournalEntriesForReportPayload,
  setData: (data: PendingJournalEntryWithLinesEntity[]) => void,
  setTotal: (total: number) => void,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.getPendingJournalEntriesForReport({
      offset: payload.offset,
      limit: payload.limit,
      fromDate: formatDateAsDdMmYyyy(payload.fromDate),
      toDate: formatDateAsDdMmYyyy(payload.toDate),
      paymentMethod: payload.paymentMethod ?? [],
      chartOfAccountIds: payload.chartOfAccountIds ?? [],
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    const body = res.data.body;
    setData(body?.data ?? []);
    setTotal(body?.total ?? 0);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
